import React, { Component, useState, forwardRef, useImperativeHandle  } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";


import { View, Text, Image, ActivityIndicator} from "react-native-web";

import { useCartStore } from "../../store/cartStore";

import HamburgerMenu from 'react-hamburger-menu';


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;


const HeaderMobile = forwardRef((props, ref) => {

  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(useCartStore.getState().items);

  const currentYear = new Date().getFullYear();

   const navigate = useNavigate();

   const location = useLocation();

   let pathname = location.pathname;


   let _user = null;
   if (props.isSignedin)
   {
      _user = JSON.parse(props.sinUser);
   }


   const user = _user;


  const uniqueItemsCount = useCartStore((state) => state.items.length);


   const signOut = () => {

     localStorage.removeItem('jwtToken');
     localStorage.removeItem('yeqolaUser');

     setTimeout(() => {
        window.location = "/";
     },100);


   }


   const handleClick = () => {
       let bool = !open;
       setOpen(bool);

       props.handleMenuClick(bool);
   }

   useImperativeHandle(ref, () => ({
       closeMenu: () => {
           setOpen(false);
       }
   }));

   const setLocale = (lang) => {



          localStorage.setItem("language", lang);
          i18n.changeLanguage(lang);


   }




    return (

      <div className="main_header" style={{backgroundColor: '#fff', width: '100%'}}>

             {props.isSignedin &&
              <div className="main_header_inside">
                  <div className="main_header_inside_left" style={{marginLeft: '0px', marginTop: '4px'}}>
                      <a href="/"><img src={'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/yeqola_logo_horiz_white_small.png'} alt="Yeqola Logo" style={{height: '50px'}}/></a>
                  </div>

                  <div className="main_header_inside_left_2" style={{display: 'none', width: '70%'}}>
                       <a href="/dplay" className="nonactiveHeaderLink">DPlay</a>
                      <a href="/about/dshop" className="nonactiveHeaderLink">DShop</a>
                      <a href="/about/dchat" className="nonactiveHeaderLink">DChat</a>
                      <a href="https://www.yinitj.com/" target="_blank" className="nonactiveHeaderLink">Youth&nbsp;Initiative&nbsp;Jeunesse</a>
                  </div>

                  <div className="main_header_inside_right_1" style={{display: 'none', float: 'right', marginRight: '10px', lineHeight: '55px', color: '#fff', fontFamily: 'Roboto'}}>
                    {i18n.language == 'fr' &&
                       <div style={{textAlign: 'right'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#fff'}}>FR</a></div>
                    }
                    {i18n.language == 'en' &&
                       <div style={{textAlign: 'right'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#fff'}}>FR</a></div>
                    }
                  </div>

                  <div className="main_header_inside_right_1" style={{marginTop: '17px', marginRight: '10px'}}>
                           <HamburgerMenu
                                isOpen={open}
                                menuClicked={handleClick}
                                width={40}
                                height={25}
                                strokeWidth={2}
                                rotate={0}
                                color='white'
                                borderRadius={0}
                                animationDuration={0.5}
                               />
                  </div>

                  <div className="main_header_inside_right_1" style={{display: 'flex', marginRight: '15px', position: 'relative', flexDirection: 'row', justifyContent: 'flex-end'}}>

                     {uniqueItemsCount > 0 &&
                       <div style={{position: 'absolute', zIndex: 3, left: '38px', backgroundColor: 'red', color: '#fff', fontSize: '16px', fontWeight: 'bold', borderRadius: '13px', minWidth: '32px', height: '26px', lineHeight: '26px', textAlign: 'center'}}>
                          {uniqueItemsCount}
                       </div>
                     }

                      <a href="/cart">
                         <View style={{cursor: 'pointer', marginTop: '2px', width: '44px', height: '44px', justifyContent: 'center'}}>
                            <Image source={{uri: 'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/cart_empty_white.png'}} style={{width: '44px', height: '44px',}}/>
                         </View>
                       </a>


                       <a href="/signin">
                          <View style={{display: 'none', cursor: 'pointer', marginLeft: '40px', marginTop: '5px', backgroundColor: '#fff', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                              borderWidth: 1, borderColor: '#fff'}}>
                             {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Roboto',}}>{`Sign in`}</Text>}
                             {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Roboto',}}>{`Se connecter`}</Text>}
                          </View>
                        </a>

                      <a href="/signup">
                        <View style={{display: 'none', cursor: 'pointer', marginLeft: '20px', marginTop: '5px', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                                   borderWidth: 1, borderColor: '#fff'}}>
                            {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto',}}>{`Sign up`}</Text>}
                            {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto',}}>{`S'enregistrer`}</Text>}
                        </View>
                     </a>

                  </div>

                  <div style={{clear: 'both'}}/>

                </div>
              }


              {!props.isSignedin &&
               <div className="main_header_inside">
                   <div className="main_header_inside_left" style={{marginLeft: '0px', marginTop: '4px'}}>
                       <a href="/"><img src={'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/yeqola_logo_horiz_white_small.png'} alt="Yeqola Logo" style={{height: '50px'}}/></a>
                   </div>

                   <div className="main_header_inside_left_2" style={{display: 'none', width: '70%'}}>
                        <a href="/dplay" className="nonactiveHeaderLink">DPlay</a>
                       <a href="/about/dshop" className="nonactiveHeaderLink">DShop</a>
                       <a href="/about/dchat" className="nonactiveHeaderLink">DChat</a>
                       <a href="https://www.yinitj.com/" target="_blank" className="nonactiveHeaderLink">Youth&nbsp;Initiative&nbsp;Jeunesse</a>
                   </div>

                   <div className="main_header_inside_right_1" style={{display: 'none', float: 'right', marginRight: '10px', lineHeight: '55px', color: '#fff', fontFamily: 'Roboto'}}>
                     {i18n.language == 'fr' &&
                        <div style={{textAlign: 'right'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#fff'}}>FR</a></div>
                     }
                     {i18n.language == 'en' &&
                        <div style={{textAlign: 'right'}}><a href="javascript:void(0)" onClick={() => setLocale("en")} style={{color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="javascript:void(0)" onClick={() => setLocale("fr")} style={{color: '#fff'}}>FR</a></div>
                     }
                   </div>


                   <div className="main_header_inside_right_1" style={{marginTop: '17px', marginRight: '10px'}}>
                            <HamburgerMenu
                                 isOpen={open}
                                 menuClicked={handleClick}
                                 width={40}
                                 height={25}
                                 strokeWidth={2}
                                 rotate={0}
                                 color='white'
                                 borderRadius={0}
                                 animationDuration={0.5}
                                />
                   </div>


                   <div className="main_header_inside_right_1" style={{display: 'flex', marginRight: '15px', position: 'relative', flexDirection: 'row', justifyContent: 'flex-end'}}>

                      {uniqueItemsCount > 0 &&
                        <div style={{position: 'absolute', zIndex: 3, left: '38px', backgroundColor: 'red', color: '#fff', fontSize: '16px', fontWeight: 'bold', borderRadius: '13px', minWidth: '32px', height: '26px', lineHeight: '26px', textAlign: 'center'}}>
                           {uniqueItemsCount}
                        </div>
                      }

                       <a href="/cart">
                          <View style={{cursor: 'pointer', marginTop: '2px', width: '44px', height: '44px', justifyContent: 'center'}}>
                             <Image source={{uri: 'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/cart_empty_white.png'}} style={{width: '44px', height: '44px',}}/>
                          </View>
                        </a>


                        <a href="/signin">
                           <View style={{display: 'none', cursor: 'pointer', marginLeft: '40px', marginTop: '5px', backgroundColor: '#fff', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                               borderWidth: 1, borderColor: '#fff'}}>
                              {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Roboto',}}>{`Sign in`}</Text>}
                              {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Roboto',}}>{`Se connecter`}</Text>}
                           </View>
                         </a>

                       <a href="/signup">
                         <View style={{display: 'none', cursor: 'pointer', marginLeft: '20px', marginTop: '5px', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                                    borderWidth: 1, borderColor: '#fff'}}>
                             {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto',}}>{`Sign up`}</Text>}
                             {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Roboto',}}>{`S'enregistrer`}</Text>}
                         </View>
                      </a>

                   </div>




                   <div style={{clear: 'both'}}/>

                 </div>
               }

      </div>

    )

});

export default HeaderMobile;
